// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"page-title_pageTitle__KZPCA"};